import {
  uuidv4,
  ValidateAssetExtensionVideo,
  ValidateAssetExtensionAudio,
  ValidateAssetExtensionImage,
  ValidateAssetExtensionFonts,
  ValidateAssetExtensionDocuments
} from '../../utils';

function removeFileNameFromPath(filePath) {
  const lastSlashIndex = filePath.lastIndexOf('/');
  if (lastSlashIndex !== -1) {
    return filePath.substring(0, lastSlashIndex + 1); // Include the last slash
  } else {
    // Handle cases where there is no slash in the path
    return filePath;
  }
}

export const createNestedStructure = (files, user) => {
  function createFolder(name, files, path) {
    return {
      type: "folder",
      name: name,
      files: files,
      id_asset: "folder",
      user: user,
      path: path
    };
  }

  const rootFolder = { type: "folder", id_asset: "folder", name: "", files: [], user: user};

  for (const file of files) {
    const { type, path, readOnly, nameBack } = file;
    const folders = path.split("/").filter(e => e !== nameBack);
    const cleanFolderPath = removeFileNameFromPath(path);
    let currentFolder = rootFolder;

    for (let i = 0; i < folders.length; i++) {
      const folderName = folders[i];

      const folderIndex = currentFolder.files.findIndex(
        (item) => item.name === folderName && item.type === "folder"
      );
      if (folderIndex !== -1) {
        currentFolder = currentFolder.files[folderIndex];
      } else {
        const newFolder = createFolder(folderName, [], cleanFolderPath);
        currentFolder.files.push(newFolder);
        currentFolder = newFolder;
      }
    }

    currentFolder.files.push({...file, type, nameBack, path, readOnly: readOnly });
  }

  return rootFolder.files;
}
export const handleFormat = size => {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
}

export const mapFilesList = (files) => {
  return files.filter(e => e.name !== ".DS_Store").map(file => {
    const uuid = uuidv4();
    const ext = file.originFileObj.name.split('.').slice(-1);
    const s3Name = `${uuid}.${ext}`;
    const absolutePath = file.originFileObj.webkitRelativePath.length > 0 ? file.originFileObj.webkitRelativePath : file.name;
    const fileToSave = {
      ...file,
      uuid,
      s3Name,
      ext,
      applyRkg: true,
      uploadObject: null,
      file: file.originFileObj,
      name: file.originFileObj.name,
      nameBack: file.originFileObj.name,
      size: file.originFileObj.size,
      path: absolutePath,
      // relativePath: relativePath,
      sizeFormat: handleFormat(file.originFileObj.size),
      type: file.originFileObj.type === 'image/x-sony-arw' ? 'document' : file.originFileObj.type,
      state: 'waiting',
      progress: 0,
      readOnly: true
    }

    let reader = new FileReader()
    reader.readAsArrayBuffer(file.originFileObj)
    reader.onloadend = (file) => {
    }
    return fileToSave
  })
}
export const mapFilesListV2 = (files) => {
  return files.filter(e => e.name !== ".DS_Store").map(file => {
    const uuid = uuidv4();
    const ext = file.originFileObj.name.split('.').slice(-1);
    const s3Name = `${uuid}.${ext}`;
    const absolutePath = file.originFileObj.webkitRelativePath.length > 0 ? file.originFileObj.webkitRelativePath : file.name;
    const fileToSave = {
      ...file,
      uuid,
      s3Name,
      ext,
      applyRkg: true,
      uploadObject: null,
      file: file.originFileObj,
      name: file.originFileObj.name,
      size: file.originFileObj.size,
      nameBack: file.originFileObj.name,
      path: absolutePath,
      // relativePath: relativePath,
      sizeFormat: handleFormat(file.originFileObj.size),
      type: file.originFileObj.type === 'image/x-sony-arw' ? 'document' : file.originFileObj.type,
      state: file.state ? file.state : 'waiting',
      progress: file.progress ? file.progress : 0,
      readOnly: file.readOnly ? file.readOnly : true
    }

    let reader = new FileReader()
    reader.readAsArrayBuffer(file.originFileObj)
    reader.onloadend = (file) => {
    }
    return fileToSave
  })
}
export const getFileType = (ext) => {
  let typeFile = "";
  if(ValidateAssetExtensionImage(ext)){
    typeFile = 'image'
  }else if(ValidateAssetExtensionDocuments(ext)){
    typeFile = 'document'
  }else if(ValidateAssetExtensionAudio(ext)){
    typeFile = 'audio'
  }else if(ValidateAssetExtensionFonts(ext)){
    typeFile = 'font'
  }else if(ValidateAssetExtensionVideo(ext)){
    typeFile = 'video'
  }else{
    typeFile = 'other'
  }
  return typeFile;
}

export const changeOpacity = (hexColor, opacity) => {
  // Convert the hexadecimal color to RGB
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  
  // Convert the opacity value from 0 to 1
  const alpha = opacity / 100;
  
  // Return the RGBA color string
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const isValidEmail = (email) => {
  // Regular expression to validate email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  // Test the email against the regular expression
  return emailRegex.test(email);
}

export const removeDuplicatesByProperty = (arr, prop) => {
  const seen = new Set();
  return arr.filter(item => {
    if (!seen.has(item[prop])) {
      seen.add(item[prop]);
      return true;
    }
    return false;
  });
}
export const extractPath = (filePath) => {
  // Split the file path into an array of directories and the file name
  const parts = filePath.split('/');

  // Remove the last element (file name) from the array
  parts.pop();

  // Join the remaining elements to form the path
  const path = parts.join('/') + '/';

  return path;
}